import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Typography,
} from "@mui/material";
import {
  ModalBaseStyles,
  ModalActionButtonStyles,
  ModalHeader,
} from "../../Common/styles/modal";

type SaveCohortConfirmationProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (data: any, action: "create" | "update") => void;
  isLoading: boolean;
  cohortName: string;
};

const SaveCohortConfirmation = ({
  open,
  onClose,
  onConfirm,
  isLoading,
  cohortName,
}: SaveCohortConfirmationProps) => {
  return (
    <Modal open={open} onClose={isLoading ? undefined : onClose}>
      <Box sx={{ ...ModalBaseStyles, minHeight: "20vh" }}>
        <ModalHeader title="Confirm Criteria Update" onCloseClick={onClose} />

        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" sx={{ color: "text.primary", mb: 1.5 }}>
            This will update the criteria for{" "}
            <Typography
              component="span"
              sx={{ fontWeight: "medium", color: "primary.main" }}
            >
              {cohortName}
            </Typography>
            .
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Do you want to proceed?
          </Typography>
        </Box>

        {/* Action Buttons */}
        <Box sx={{ ...ModalActionButtonStyles, mt: 3 }}>
          <Button
            variant="outlined"
            onClick={onClose}
            disabled={isLoading}
            data-testid="button-cancel-criteria-update"
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
            }}
          >
            Cancel
          </Button>

          <Button
            type="button"
            variant="contained"
            disabled={isLoading}
            onClick={() =>
              onConfirm(
                {
                  name: cohortName,
                },
                "create"
              )
            }
            autoFocus
            data-testid="button-confirm-criteria-update"
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
            }}
          >
            {isLoading ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CircularProgress size={16} color="inherit" />
                Updating...
              </Box>
            ) : (
              "Confirm"
            )}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SaveCohortConfirmation;
